import type { ReactNode, TableHTMLAttributes } from 'react';
import { tbl, tblWide, tblWrap } from './Table.css';

// Scroll container + bordered/rounded surface that wraps every data table in the
// app. Replaces the repeated `<div className={tblWrap}>` boilerplate.
export function TableWrap({ children }: { children: ReactNode }) {
  return <div className={tblWrap}>{children}</div>;
}

interface TableProps extends TableHTMLAttributes<HTMLTableElement> {
  /** Apply the wide-table min-width (horizontal scroll on narrow viewports). */
  wide?: boolean;
}

// The `<table>` element carrying the shared header/cell styling (driven by the
// `tbl` class + its descendant globalStyles). Column/cell markup stays in the
// caller — this only owns the chrome that every table shares.
export function Table({ wide, className, children, ...rest }: TableProps) {
  const classes = [tbl, wide && tblWide, className].filter(Boolean).join(' ');
  return (
    <table className={classes} {...rest}>
      {children}
    </table>
  );
}
